module.exports = __webpack_public_path__ + "static/media/IMG_2114_OK_DH1.0777b716.jpg";